/* eslint-disable import/prefer-default-export, @typescript-eslint/no-explicit-any */
import { defineStore } from 'pinia';

import { ObjectQueue } from '@scripts/utils/containers';

type AutocompoleteStoreStateType = {
  cache: {
    tenantSkills: ObjectQueue;
    tenantUsers: ObjectQueue;
    tenantTags: ObjectQueue;
  };
};

const TENANT_SKILLS_CACHE_SIZE = 50;
const TENANT_USERS_CACHE_SIZE = 50;
const TENANT_TAGS_CACHE_SIZE = 50;

const initialState = (): AutocompoleteStoreStateType => ({
  cache: {
    tenantSkills: new ObjectQueue({ size: TENANT_SKILLS_CACHE_SIZE }),
    tenantUsers: new ObjectQueue({ size: TENANT_USERS_CACHE_SIZE }),
    tenantTags: new ObjectQueue({ size: TENANT_TAGS_CACHE_SIZE }),
  },
});

export const useAutocompleteStore = defineStore({
  id: 'autocomplete',
  state: initialState,
  getters: {
    cacheExists: (state) => ({
      target,
      key,
    }: {
      target: string;
      key: number | string;
    }): boolean => !!state.cache[target] && !!state.cache[target].get({ key }),
  },
  actions: {
    $reset() {
      Object.assign(this, initialState());
    },
    setCache({
      target,
      key,
      item,
      throwException = false,
    }: {
      target: string;
      key: string | number;
      item: any;
      throwException?: boolean;
    }): void {
      if (!this.cache[target]) {
        if (throwException) {
          throw new Error(
            `autocompleteStore.setCache error. ${target} not found as a key.`,
          );
        }
      } else {
        this.cache[target].enqueue({ key, item });
      }
    },
  },
});
